'use strict';

/**
 * Module definition for the import dialog
 *
 * @category   Module
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Controller = require('./controller');

var ImportModule = Marionette.Module.extend({
    startWithParent: true,

    initialize: function(moduleName, app) {
        this.app = app;
    },

    onStart: function(options) {
        var app = this.app;

        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        app.addInitializer(function(){
            app.router.processAppRoutes(controller, controller.routes);
        }.bind(this));
    },
});

module.exports = ImportModule;